const delegate = require('delegate');
import { str2json } from '@utils';

export default {
  init: function (app) {
    this.app = app;
    this.bindEvents();
  },

  bindEvents: function () {
    // Make the entire block clickable
    delegate(
      document.body,
      '.has-link',
      'click',
      (e) => {
        // If already a link bailout
        if (e.target.tagName == 'A' || e.target.tagName == 'BUTTON') {
          return;
        }
        const link = e.delegateTarget.querySelector('a[has-link-target]') ? e.delegateTarget.querySelector('a[has-link-target]') : e.delegateTarget.querySelector('a');
        if (link && link.href) {
          e.preventDefault();
          window.open(link.href, link.target ? link.target : '_self');
        }
      },
      false
    );


    delegate(
      document.body,
      '[data-action]',
      'click',
      (e) => {
        e.preventDefault();
        const evData = str2json(e.delegateTarget.dataset.action);
        const exclude = ['A', 'BUTTON']
        if (!exclude.includes(evData.target.tagName && !evData.hasOwnProperty('data-action'))) {
          this.app.emit(evData.type, { identifier: evData.target, action: evData.action, focusOrigin: e.delegateTarget });
        }
      },
      false
    );

    delegate(
      document.body,
      '[data-action]',
      'keypress',
      (e) => {
        e.preventDefault();
        if (e.keyCode === 32 || e.keyCode === 13) {
          const evData = str2json(e.delegateTarget.dataset.action);
          this.app.emit(evData.type, { identifier: evData.target, action: evData.action, focusOrigin: e.delegateTarget });
        }
      },
      false
    );

    delegate(
      document.body,
      '[data-key-press]',
      'keydown',
      (e) => {
        const evData = str2json(e.delegateTarget.dataset.keyPress);
        if (e.key === evData.key) {
          this.app.emit(evData.type, { identifier: evData.target, action: evData.action });
        }
      },
      false
    );

    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      if (links[i].hostname !== window.location.hostname && links[i].target != '_blank') {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }

    document.addEventListener("DOMContentLoaded", () => {
      jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
        if (formId == "2" || formId == "3") {
          localStorage.setItem("enable-download-report", true);
        }
      })
    })
  },
};
